import { render, staticRenderFns } from "./reviewTicketFcp.vue?vue&type=template&id=241da9c2&lang=pug"
import script from "./reviewTicketFcp.vue?vue&type=script&lang=js"
export * from "./reviewTicketFcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports